import React from "react";
import { Trophy, X, RefreshCw } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * Modal-style summary shown after a session ends.
 * Props: tasks, correct, onClose, onRetry
 */
export default function SessionResult({ tasks, correct, onClose, onRetry }) {
  const { t } = useLanguage();
  const accuracy = tasks > 0 ? Math.round((correct / tasks) * 100) : 0;
  return (
    <div
      className="vls-result-backdrop"
      role="dialog"
      aria-modal="true"
      data-testid="session-result"
    >
      <div className="vls-result-card">
        <div className="vls-result-icon">
          <Trophy size={36} />
        </div>
        <h2 className="vls-result-title">{t("sessionResult")}</h2>
        <div className="vls-result-grid">
          <div className="vls-result-item">
            <span className="vls-result-num" data-testid="result-tasks">{tasks}</span>
            <span className="vls-result-lbl">{t("tasksLabel")}</span>
          </div>
          <div className="vls-result-item">
            <span
              className="vls-result-num vls-grad-cyan"
              data-testid="result-correct"
            >
              {correct}
            </span>
            <span className="vls-result-lbl">{t("correctLabel")}</span>
          </div>
          <div className="vls-result-item">
            <span
              className="vls-result-num vls-grad-orange"
              data-testid="result-accuracy"
            >
              {accuracy}%
            </span>
            <span className="vls-result-lbl">{t("accuracyLabel")}</span>
          </div>
        </div>
        <div className="vls-result-actions">
          <button
            type="button"
            className="vls-btn-secondary"
            onClick={onClose}
            data-testid="result-close"
          >
            <X size={18} />
            <span>{t("close")}</span>
          </button>
          {onRetry && (
            <button
              type="button"
              className="vls-btn-primary"
              onClick={onRetry}
              data-testid="result-retry"
            >
              <RefreshCw size={18} />
              <span>{t("tryAgain")}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
